import { useCustomTheme } from '../../../../../../../../hooks/useCustomTheme';
import { Font } from '../../../../../../../shared/components/Font';
import { SizedIconWithCircle } from '../../../../../../../shared/components/SizedIconWithCircle';
import { Text } from '../../../../../../../shared/components/Text';
import { TRANSACTION_TYPES_DEFINITIONS } from '../../../constants/constants';
import { TransactionsListRowProps } from '../../../types/TransactionsListRowProps';

export const transactionTypeFieldColumn = ({ flex }: { flex?: number }) => {
  const { palette, customBorderRadius } = useCustomTheme();
  return {
    flex: flex ?? 0.3,
    field: 'type',
    headerName: <Text tId={'TRANSACTION_TYPE'} />,
    disableOnRowClick: true,
    renderCell: (rowData: TransactionsListRowProps) => {
      return (
        <>
          <SizedIconWithCircle
            variant={'medium'}
            backgroundColor={palette.grey[50]}
            iconColor={palette.grey[500]}
            customBorderRadius={customBorderRadius.button}
            iconName={TRANSACTION_TYPES_DEFINITIONS[rowData.row.type].iconName}
            copyToClipboard={{ value: rowData.row.id, textId: 'COPY_TRANSACTION_ID' }}
          />
          <Font variant={'body2'} color={'textSecondary'} style={{ marginLeft: 6 }}>
            <Text tId={rowData.row.type} />
          </Font>
        </>
      );
    },
  };
};
